import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Flat icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Flat } from '@sravni/design-system-icons'
 *
 * <Flat />
 * ```
 */
var Flat = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Flat", viewBox: "0 0 21 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M6.736 18.96V3.993h-3.2c-.441 0-.8.447-.8.998V18.96M18.736 18.96V4.99c0-.55-.358-.997-.8-.997h-3.2V18.96M18.656 19l-3.92-.04M6.736 18.96l-3.92.04", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { clipRule: "evenodd", d: "M6.736 18.96h8V2.038c0-.573-.358-1.038-.8-1.038h-6.4c-.441 0-.8.465-.8 1.038V18.96Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M9.236 14h3M9.236 10h3M9.236 6h3", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { Flat };
//# sourceMappingURL=Flat.js.map
